import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { HttpService } from '../../../services/http/http.service';
import { AddressApiResponse, IAddress, IChangePasswordResponse, IUpdatePhoneNumberResponse } from '../../../interfaces/IProfile';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  isProfileUpdated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private data: DataService, private http: HttpService) {}

  saveAddress(addressPayload: IAddress,updatePropertyAddress:boolean): Observable<AddressApiResponse> {
    const auth0UserId = this.data.auth0UserId.getValue();
    const contractNumber =
      this.data.contractData$.getValue()?.baseContract?.contractNumber;

    if (!auth0UserId || !contractNumber) {
      // Throw an error or return a meaningful observable if values are missing
      throw new Error('User ID or contract number is missing');
    }
    let url: string;
    if (updatePropertyAddress)
      url = `/api/${auth0UserId}/contracts/${contractNumber}/property/address`;
    else
      url = `/api/${auth0UserId}/contracts/${contractNumber}/address`;
    return this.http.put<AddressApiResponse>(url, addressPayload);
  }

  updatePassword(password: string): Observable<IChangePasswordResponse> {
    const url = `/api/auth`;
    return this.http.post<IChangePasswordResponse>(url, {
      type: 'change-password',
      sub: this.data.auth0UserId.getValue(),
      newPassword: password,
    });
  }

  validatePhoneNumber(phoneNumber:string):Observable<IUpdatePhoneNumberResponse>{
    const url =`api/public/user/validateMobileNumber?phoneNumber=${phoneNumber}`
    return this.http.get<IUpdatePhoneNumberResponse>(url);
  }
}
